export default "__VITE_ASSET__DtroPSVc__"